import { isEmpty, isEqual } from "lodash";
import { postUserLog } from "../../actions/common";

export const postLogForFilter = (
  gridRef,
  gridEvent,
  siteUId,
  tierId,
  boxName,
  boxNumber,
  rpsId,
  navigationOn
) => {
  const { name, fullName, value } = gridEvent;

  if (
    name === "columns" &&
    !isEmpty(value) &&
    ["filterType", "filterValue", "filterValues"].includes(
      fullName.split(".")[1]
    )
  ) {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();

    const colName = visibleColumns.filter((col) =>
      isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
    )[0]?.dataField;

    if (!isEmpty(colName)) {
      postUserLog({
        event: `Box ${boxNumber} - ${boxName} Filter`,
        data: {
          action: `${colName} filtered/searched for A3-${rpsId}`,
          module: "Digital Tier",
          section: navigationOn,
          siteUId,
          widget: "Strategic A3",
          tierId,
        },
      });
    }
  }
  
  /* KEPT THIS FOR ONE MORE LOG - COLUMN CHOOSER - WIP*/
  // if (
  //   name === "columns" &&
  //   !isEmpty(value) &&
  //   ["visible"].includes(fullName.split(".")[1])
  // ) {
  //   const currentVisibleColumns = gridRef.current.instance.getVisibleColumns();
  //   const regex = /\[(\d+)\]/;
  //   const columnIndex = fullName.match(regex);
  // }
};

export const postLogForGridOperations = (
  gridRef,
  gridEvent,
  siteUId,
  tierId,
  eventName,
  rpsId,
  navigationOn
) => {
  const { name, fullName, value } = gridEvent;
  if (
    name === "columns" &&
    !isEmpty(value) &&
    ["filterType", "filterValue", "filterValues"].includes(
      fullName.split(".")[1]
    )
  ) {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();
    const colName = visibleColumns.filter((col) =>
    isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
  )[0]?.caption
    ? visibleColumns.filter((col) =>
        isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
      )[0]?.caption
    : visibleColumns.filter((col) =>
        isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
      )[0]?.dataField;
    if (!isEmpty(colName)) {
      postUserLog({
        event:  "A3 Grid Filter",
        data: {
          action: `Filters/Search applied to ${colName}`,
          module: "Digital Tier",
          section:navigationOn,
          siteUId,
          widget: "Strategic A3",
          tierId
        },
      });
    }
  }
  
  if (
    name === "columns" &&
    !isEmpty(value) &&
    ["filterType", "filterValue", "filterValues"].includes(
      fullName.split(".")[1]
    )
  ) {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();

    // Get Column name from caption key if available. else get datafield value
    const colName = visibleColumns.filter((col) =>
      isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
    )[0]?.caption
      ? visibleColumns.filter((col) =>
          isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
        )[0]?.caption
      : visibleColumns.filter((col) =>
          isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
        )[0]?.dataField;

    // filtered Individual column
    if (
      fullName.split(".")[1] === "filterValues" &&
      typeof value === "object" &&
      !isEmpty(colName)
    ) {
      postUserLog({
        event:  "A3 Grid Filter",
        data: {
          action: `Filters/Search applied to ${colName}`,
          module: "Digital Tier",
          section:navigationOn,
          siteUId,
          widget: "Strategic A3",
          tierId
        },
      });
    }
  }

  if (name === "paging" && fullName.split(".")[1] === "pageIndex") {
    const { previousValue } = gridEvent;
    if (
      Math.abs(value - previousValue) === 1 ||
      (previousValue === undefined && value === 1)
    ) {
      postUserLog({
        event: "A3 Grid View",
        data: {
          action: `A3 Grid ${
            previousValue === undefined
              ? "Next"
              : previousValue < value
              ? "Next"
              : "Previous"
          } Page - Page ${value + 1} clicked`,
          module: "Digital Tier",
          section:navigationOn,
          siteUId,
          widget: "Strategic A3",
          tierId
        },
      });
    }

  }
  // Page size showing log
  if (name === "paging" && fullName.split(".")[1] === "pageSize") {
    postUserLog({
      event: `${eventName} View`,
      data: {
        action: `A3 Grid expanded to ${value} items`,
        module: "Digital Tier",
        section:navigationOn,
        siteUId,
        widget: "Strategic A3",
        tierId
      },
    });
  }
};

export const getPickStatus = (benefit, difficulty) => {
  if (benefit <= 5 && difficulty <= 5) return "Possible";
  else if (benefit > 5 && difficulty <= 5) return "Implement";
  else if (benefit <= 5 && difficulty > 5) return "Kill";
  else if (benefit > 5 && difficulty > 5) return "Challenge";
};

export const isSubPropertyUnique = (array, subProperty) => {
  const seen = new Set();

  let isUnique = true;
  array.forEach((obj) => {
    obj.subwhys.forEach((subObj) => {
      if (seen.has(subObj[subProperty])) {
        isUnique = false; // Subproperty is not unique
      }
      seen.add(subObj[subProperty]);
    });
  });

  return isUnique;
};